export default "__VITE_ASSET__aef90903__"